class Security {

    static base64Encode(value) {

        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }

        return btoa(value);
    }

    static base64Decode(value, parseAsJson) {

        value = atob(value);

        return parseAsJson ? JSON.parse(value) : value;
    }

    static stringMask(value, mask) {

        var string = '';

        if (value.length) {
            for (var i = value.length - 1; i >= 0; i--) {
                var char = value.charCodeAt(i),
                    maskedBinary = (char ^ (mask % 65535)).toString(2),
                    maskedChar = maskedBinary[0];

                for (var j = 1; j < maskedBinary.length; j++) {
                    maskedChar += parseInt(maskedBinary[j], 2) === 0 ? 1 : 0;
                }

                string += String.fromCharCode(parseInt(maskedChar, 2));
            }
        }

        return string;
    }

    static stringUnmask(value, mask) {

        var string = '';

        if (value.length) {
            for (var i = value.length - 1; i >= 0; i--) {
                var char = value.charCodeAt(i),
                    unmaskedBinary = (char).toString(2),
                    unmaskedChar = unmaskedBinary[0];

                for (var j = 1; j < unmaskedBinary.length; j++) {
                    unmaskedChar += parseInt(unmaskedBinary[j], 2) === 0 ? 1 : 0;
                }

                unmaskedChar = parseInt(unmaskedChar, 2) ^ (mask % 65535);
                string += String.fromCharCode(unmaskedChar);
            }
        }

        return string;
    }

    static basicAuthenticate(email, password) {

        var credential = '',
            encodedCredential = '',
            basicAuthString = '';

        if( (!email) || (!password) ) {
            console.error("No email or password provided.");
        } else {
            credential = email + ':' + password;
            encodedCredential = this.base64Encode(credential);
            basicAuthString = 'Basic ' + encodedCredential;
        }

        return basicAuthString;
    }

}

export default Security;


// WEBPACK FOOTER //
// ./src/helpers/security.js